import { createQuery } from "@/api/utils";
import {
    MemoText,
    MemoTextTypeEnum,
    MemoTextTypeParams,
} from "./MemoText.model";

export const getMemoTexts = createQuery<MemoText[], MemoTextTypeParams>(
    async ({ api, router, params }) => {
        const response = await api.get(
            `/deal-flow/alpha/companies/${router.params.companyId}/memo-texts${params.type ? `?type=${params.type}` : ""}`,
        );

        return (
            response.items?.map((item) => ({
                ...item,
                type: item.id as MemoTextTypeEnum,
            })) || []
        );
    },
);
